import * as Constants from '@emi/shared/constants';
import { DynamicExchangeRate } from './dynamic-exchange-rate';
import { MinMaxRange } from './min-max-range';
import { TotalSKUSizeRange } from './total-sku-size';
import { FileTypes } from './types/file-types.type';
import { Frequency } from './types/frequency.type';
import { PricePer } from './types/price-per.type';
import { TimeSeriesData } from './types/time-series-data.type';
import { ViewBy } from './types/view-by.type';

export class ConfigureData {
    constructor(
        public startDate?: Date,
        public endDate?: Date,
        public searchPhrase: string = '',
        public pricePoint: PricePer = Constants.Application.DEFAULT_PRICE_PER,
        public frequency: Frequency = Constants.Application.DEFAULT_FREQUENCY,
        public viewBy: ViewBy = Constants.Application.DEFAULT_VIEW_BY,
        public currency: string = 'USD',
        public dataType: TimeSeriesData[] = [],
        public includeAttributesFile: boolean = false,
        public fileType: FileTypes = 'CSV',
        public firstSeenPriceRange: MinMaxRange | null = null,
        public lastSeenPriceRange: MinMaxRange | null = null,
        public volumeRange: TotalSKUSizeRange | null = null,
        public weightRange: TotalSKUSizeRange | null = null,
        public countRange: TotalSKUSizeRange | null = null,
        public exchangeRates: DynamicExchangeRate[] = []
    ) { }
}
